export class PluginValidationModel {
    config = {
        // Minimum allowed incoming connectors
        minIncoming: 1,
        // Minimum allowed outgoing connectors
        minOutgoing: 1,
        // Maximum allowed incoming connectors
        maxIncoming: 10000,
        // Maximum allowed outgoing connectors
        maxOutgoing: 10000,
        // If the specified plugin is mandatory to exist on the diagram
        mandatory: false,
        // If is mandatory, how many instances are they mandatory to exist.
        mandatoryCount: 0,
        // Maximum number of plugin instances of the diagram
        // Numeric or function value. If is function, a callback is provided to check for the validity
        maxInstances: 10000,
        // Maximum number of plugin instances of the diagram
        // Numeric or function value. If is function, a callback is provided to check for the validity
        minInstances: 0,
        // custom validators - functions that must return an array of errors or true if it passed all validations. They recieve an object as parameter containing:
        // parsedConnectors - Parsed connectors UUID up until the parsation of this plugin
        // parsedPlugins - Parsed plugins UUID up until the parsation of this plugin
        // pluginCounts - Number of plugin instances up until the parsation of this plugin
        // diagramData - Diagram Object
        // diagramConfigData: Daca diagramValidator este initializat cu al 2 lea parametru obiectul de diagramConfigData o sa il primesti pe callback-ul de validare
        // currentPlugin: plugin - Pluginul la care se ajuns in parsare
        // currentPluginValidation: validation - Validarile tipului curent de plugin
        custom: []
    };

    constructor(options) {
        if (options) {
            this.config = { ...this.config, ...options };
            if (this.config.mandatory && this.config.mandatoryCount === 0) this.config.mandatoryCount = 1;
        }
    }

    getMinIncoming() {
        return this.config.minIncoming;
    }

    getMinOutgoing() {
        return this.config.minOutgoing;
    }

    getMaxIncoming() {
        return this.config.maxIncoming;
    }

    getMaxOutgoing() {
        return this.config.maxOutgoing;
    }

    isMandatory() {
        return this.config.mandatory;
    }

    getMandatoryCount() {
        return this.config.mandatoryCount;
    }
}
